import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAll = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#34B288'
      d='M3.333 11.667c0-.46.373-.834.834-.834H12.5a.833.833 0 1 1 0 1.667H4.167a.833.833 0 0 1-.834-.833M3.333 15c0-.46.373-.833.834-.833h11.666a.833.833 0 0 1 0 1.666H4.167A.833.833 0 0 1 3.333 15'
    />
    <path
      fill='#EB4763'
      d='M3.333 5c0-.46.373-.833.834-.833h11.666a.833.833 0 0 1 0 1.666H4.167A.833.833 0 0 1 3.333 5M3.333 8.333c0-.46.373-.833.834-.833H12.5a.833.833 0 1 1 0 1.667H4.167a.833.833 0 0 1-.834-.834'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAll)
export default ForwardRef
